import React, { FC } from 'react';
import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EconsultActionButton } from '@oh-vcp/components-ui';

interface EconsultRedirectDialogProps {
  isDialogOpen: boolean;
  onContine: () => void;
  onCancel: () => void;
}

const EconsultRedirectDialog: FC<EconsultRedirectDialogProps> = ({
  isDialogOpen,
  onContine,
  onCancel
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isDialogOpen}>
      <DialogTitle variant="h2" sx={{ color: 'base.grey4' }}>
        {t('Case.consult.redirectCase')}
      </DialogTitle>
      <DialogContent sx={{ width: 400 }}>
        <Typography variant="body2" component="p" sx={{ color: 'base.grey4' }}>
          {t('Case.consult.assignerRedirectNote1')}
        </Typography>
        <Typography variant="body2" component="p" mt={1} sx={{ color: 'base.grey4' }}>
          {t('Case.consult.assignerRedirectNote2')}
        </Typography>
        <Stack direction="row" columnGap={2} mt={2} justifyContent="flex-end">
          <EconsultActionButton size="large" variant="contained" onClick={() => onContine()}>
            {t('Case.consult.redirect')}
          </EconsultActionButton>
          <EconsultActionButton size="large" variant="contained" onClick={() => onCancel()}>
            {t('Case.button.cancel')}
          </EconsultActionButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default EconsultRedirectDialog;
